
export function dateFormat(date) {
    return new Date(date).toLocaleString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function timeFormat(date) {
    return new Date(date).toLocaleString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })
}

export function timeDiffInMin(d1, d2) {
    var diffMs = (new Date(d1) - new Date(d2));
    return Math.round(((diffMs % 86400000) % 3600000) / 60000);
}
export function getAge(d1) {
    let d2 = new Date();
    let diff = d2.getTime() - d1.getTime();
    let exp = (diff / (1000 * 60 * 60 * 24 * 365.25)).toFixed(1);

    if(exp == 0){
       return  'Infant'
    } else if (exp < 1) {
        if(((exp % 1).toFixed(1).substring(2)) == 1){
            return (exp % 1).toFixed(1).substring(2) + ' month'
        }
        return (exp % 1).toFixed(1).substring(2) + ' months'
    }
    else if (Math.round(exp) == 1) {
        return Math.round(exp) + ' year'
    }
    else if (Math.round(exp) > 1) {
        return Math.round(exp) + ' years'
    }
}

export function getExperience(d1, d2) {
    d2 = d2 || new Date();
    let diff = d2.getTime() - d1.getTime();
    let exp = (diff / (1000 * 60 * 60 * 24 * 365.25)).toFixed(1);

    if(exp == 0){
       return  '(0-1) year of experience'
    }
    if (exp < 1) {
        if(((exp % 1).toFixed(1).substring(2)) <= 6){
            return '(0-1) year of experience'
        }
        return (exp % 1).toFixed(1).substring(2) + ' months of experience'
    }
    else if (Math.round(exp) == 1) {
        return Math.round(exp) + ' year of experience'
    }
    else if (Math.round(exp) > 1) {
        return Math.round(exp) + ' years of experience'
    }

}

export function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function getMinutesBetweenDates(startDate, endDate) {
    var diff = endDate.getTime() - startDate.getTime();
    return (diff / 60000);
}

export function displayFullName (user) {
    let name = user.firstName ? user.firstName : "";
    name += user.lastName && user.lastName !== '' ? ' ' + user.lastName : '';
    return name;
} 